// 处理表单数据
function getDimeValue(dimeObj) {
  let dimeValue = null
  if(dimeObj.editType == '3' || dimeObj.editType == '6') { // 下拉框 || 单选框
    if(dimeObj.options) {
      // let dimeArr = []
      // console.log(111);
      // console.log(dimeObj);
      // console.log(JSON.parse(dimeObj.options).find(arr => arr.optionValue == dimeObj.dimeValue));
      // dimeArr.push(JSON.parse(dimeObj.options).find(arr => arr.optionValue == dimeObj.dimeValue).optionLabel)
      JSON.parse(dimeObj.options).forEach(el => {
        if(dimeObj.dimeValue == el.optionValue) {
          dimeValue = el.optionLabel
        }
      })
      // dimeValue = dimeArr.toString()
    }
    if(!dimeValue) {
      dimeValue = dimeObj.dimeValue
    }
  }else if(dimeObj.editType == '7' && dimeObj.dimeValue) { // 多选框
    if(typeof(dimeObj.dimeValue) != 'object') {
      dimeObj.dimeValue = JSON.parse(dimeObj.dimeValue)
    }
    let dimeArr = []
    if(dimeObj.options) {
      // dimeObj.dimeValue.forEach(item => {
      //   // console.log(222);
      //   // console.log(JSON.parse(dimeObj.options).find(arr => arr.optionValue == item));
      //   dimeArr.push(JSON.parse(dimeObj.options).find(arr => arr.optionValue == item).optionLabel)
      // })

      JSON.parse(dimeObj.options).forEach(val => {
        dimeObj.dimeValue.forEach(el => {
          if(val.optionValue == el) {
            // str += val.optionLabel + ', '
            dimeArr.push(val.optionLabel)
          }
        })
      })
    }else {
      dimeArr = dimeObj.dimeValue
      // dimeObj.dimeValue.forEach(val => {
      //   str += val + ', '
      // })
    }
    dimeValue = dimeArr.toString()
  }else if(dimeObj.editType == '8' && dimeObj.dimeValue) { // 附件
    if(typeof(dimeObj.dimeValue) != 'object') {
      dimeValue = JSON.parse(dimeObj.dimeValue)
    }else {
      dimeValue = dimeObj.dimeValue
    }
  }else if(dimeObj.editType == '11' && dimeObj.dimeValue) { // 百分比
    dimeValue = dimeObj.dimeValue + '%'
  }else if(dimeObj.editType == '12') { // 资源
    let dimeArr = []
    if(dimeObj.options) {
      dimeObj.dimeValue.forEach(item => {
        dimeObj.options.forEach(val => {
          if(val.ofrResourceId == item) {
            dimeArr.push(val.resourceName)
          }
        })
        // dimeArr.push(dimeObj.options.find(arr => arr.ofrResourceId == item).resourceName)
      })
    }else {
      dimeArr = dimeObj.dimeValue
    }
    dimeValue = dimeArr.toString()
  }else if(dimeObj.editType == '13') { // 内容
    let dimeArr = []
    if(dimeObj.options) {
      dimeObj.options.forEach(val => {
        let a = val.ofrThingList.filter(list => dimeObj.dimeValue.map(Number).includes(Number(list.ofrThingId)))
        if(a.length > 0){
          dimeArr.push(...a.map(item => item.name))
        }
      })
    }else {
      dimeArr = dimeObj.dimeValue
    }
    dimeValue = dimeArr.toString()
  }else if(dimeObj.editType == '14') { // 项目
    // console.log(dimeObj);
    let dimeArr = []
    if(dimeObj.options) {
      dimeObj.options.forEach(val => {
        let a = val.ofoFlowItemList.filter(list => dimeObj.dimeValue.map(Number).includes(Number(list.ofoItemId)))
        if(a.length > 0){
          dimeArr.push(...a.map(item => item.name))
        }
      })
    }else {
      dimeArr = dimeObj.dimeValue
    }
    dimeValue = dimeArr.toString()
  }else if(dimeObj.editType == '20') { // 下拉树
    // console.log(dimeObj);
    if(dimeObj.options) {
      let data = JSON.parse(JSON.stringify(dimeObj.options))
      // const flattenedArray = getOneArr(data)
      dimeValue = getNodePathById(data, dimeObj.dimeValue)
      // console.log(flattenedArray);
      // flattenedArray.forEach(el => {
      //   if(dimeObj.dimeValue == el.id) {
      //     dimeValue = el.label
      //   }
      // })
    }
    if(!dimeValue) {
      dimeValue = dimeObj.dimeValue
    }
  }else {
    dimeValue = dimeObj.dimeValue
  }
  return dimeValue
}

function getOneArr (data) {
  let newData = []
  const callback = (item) => {
    (item.children || (item.children = [])).map(v => {
      callback(v)
    })
    delete item.children
    newData.push(item)
  }
  data.map(v => callback(v))
  return newData
}

function getNodePathById (data, targetId) {
  if (!targetId) return ''
  let pathString = ''

  const findPath = (items, currentPath = []) => {
    for (const item of items) {
      // 当前路径加上当前节点
      const newPath = [...currentPath, item.label || item.name]

      // 如果找到目标ID
      if (item.id === targetId) {
        pathString = newPath.join(' / ')
        return true
      }

      // 如果有子节点，递归查找
      if (item.children && item.children.length) {
        const found = findPath(item.children, newPath)
        if (found) return true
      }
    }
    return false
  }

  findPath(data)
  return pathString
}

export default function handleDimes(list, isObj) {
  let arr = []
  list.forEach(item => {
    if(isObj) {
      arr.push({
        ...item,
        cbdId: item.cbdId,
        dimeValue: item.dimeValue,
        dimeText: item.dimeValue ? getDimeValue(item) : ''
      })
    }else {
      arr.push({
        cbdId: item.cbdId,
        dimeValue: item.dimeValue,
        dimeText: item.dimeValue ? getDimeValue(item) : ''
      })
    }

  })
  return arr
}
